interface InfoWithEmailAddress {
    emailAddress: string;
}

export function findEmailAddress(emailAddress: string, infos: InfoWithEmailAddress[]): boolean {
    return infos.some(info => info.emailAddress === emailAddress);
}
